require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/es7.symbol.observable.js
// module id = 847
// module chunks = 0